import React from 'react';
import MedicalRequestPolandForm, {
	MedicalRequestPolandFormValues,
} from './MedicalRequestPolandForm';
import useNotification from '../../../../../Hooks/useNotification.hook';
import useApiClient from '../../../../Base/Hooks/useApiClient';
import { useCreateP1MedicalRequestMutation } from '../../../../../graphql/graphql';
import useLoading from '../../../../Base/Hooks/useLoading';
import useP1Patient from '../../../Hooks/useP1Patient';
import P1InvalidPatientDataMessage from '../P1InvalidPatientDataMessage/P1InvalidPatientDataMessage';

interface Props {
	patientId: string;
	onSuccess: (jobId: string) => void;
}

const MedicalRequestPoland: React.FC<Props> = ({ patientId, onSuccess }) => {
	const { showNotificationSuccess } = useNotification();
	const { displayError, displayGQLError } = useApiClient();
	const { isLoading, setIsLoading, RenderLoading } = useLoading();
	const { isPatientValid, isLoadingP1Patient } = useP1Patient(patientId);

	const [createP1MedicalRequest] = useCreateP1MedicalRequestMutation();

	const handleSubmit = async (values: MedicalRequestPolandFormValues) => {
		setIsLoading(true);

		try {
			const secondaryDiagnoses: string[] = [];

			values.secondaryDiagnoses?.forEach(item => {
				if (item?.item?.value)
					secondaryDiagnoses.push(item.item.value as string);
			});

			const response = await createP1MedicalRequest({
				input: {
					patientId,
					medicalFacilityId: values.medicalFacility.value as string,
					procedureId: values.procedure?.value as string | undefined,
					requestTypeId: values.requestType.value as string,
					note: values.note,
					primaryDiagnose: values.primaryDiagnose.value as string,
					secondaryDiagnoses,
				},
			});

			displayGQLError(response);
			if ('data' in response) {
				if (response.data.createP1MedicalRequest?.jobId) {
					showNotificationSuccess({
						content: 'component.medicalRequestPoland.successMessage',
					});
					onSuccess(response.data.createP1MedicalRequest.jobId);
				}
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading || isLoadingP1Patient) {
		return <RenderLoading />;
	}

	if (!isPatientValid) {
		return <P1InvalidPatientDataMessage />;
	}

	return (
		<>
			<MedicalRequestPolandForm patientId={patientId} onSubmit={handleSubmit} />
		</>
	);
};

export default MedicalRequestPoland;
